import CaterIndustry from "../../Sections/CaterIndustry";
import FirstTime from "../../Sections/FirstTime";
import HowItWorks from "../../Sections/HowItWorks";
import ServiceCard from "../../Sections/ServiceCard";
import BottomNav from "../../Layout/BottomNav";
import { useEffect } from "react";
import { Helmet } from "react-helmet";
import ConvertedPrice from "../ConvertedPrice";

const GraphicDesignPage = (props: any) => {
  useEffect(() => {
    if (window.location.hash) {
      const element = document.querySelector(
        window.location.hash
      ) as HTMLElement | null;
      const header = document.querySelector(
        ".main-header-tabs"
      ) as HTMLElement | null; // Replace '.sticky-header' with your header selector
      const headerHeight = header?.offsetHeight || 0;

      setTimeout(() => {
        if (element) {
          const elementPosition =
            element.getBoundingClientRect().top + window.pageYOffset; // Element's position from the top
          const offsetPosition = elementPosition - headerHeight - 50; // Adjust for header height

          window.scrollTo({
            top: offsetPosition,
            behavior: "smooth",
          });
        }
      }, 500);
    }
  }, [window.location]);

  return (
    <>
      <Helmet>
        <title>
          Business Card, Digital Display , Logo Branding design | Stagobox
        </title>
        <meta
          name="description"
          content="Boost your brand with Stagobox! Get custom logo design, business cards, vector illustrations & digital displays starting at $8. High-quality & creative solutions"
        />
      </Helmet>
      <BottomNav />

      {/* <WeCanDO /> */}

      <div className="blur-background-box">
        <div className="hp-container">
          <div className="page-title pt-5" data-aos="fade-up">
            <h1>Graphic Designing</h1>
            <p>
              Unlock the full potential of your real estate marketing with our
              amazing graphic design services! We're talking logo and branding,
              poster design, vector design, and digital display design—all
              crafted specifically for the real estate world. Imagine stunning
              visuals that make your brands impact-full and captivating . Let’s
              elevate your brand and make waves in the competitive real estate
              market together!
            </p>
          </div>

          <section id="graphic-design-section">
            <h2 className="mb-5 mt-5 pb-5">
              <span className="underLine">
                Services we provide under Graphic Designing
              </span>
            </h2>

            <ServiceCard
              singleImage={true}
              imageFront={`${process.env.REACT_APP_ADMIN_STORAGE_URL}/Business_Card_designing_Web_1749844783.webp`}
              imageBack={`${process.env.REACT_APP_ADMIN_STORAGE_URL}/Business_Card_designing_Web_1749844783.webp`}
              description="Looking to make a great first impression? Our Business Card Designing service is here to help! We perfect every detail, creating business cards that make a lasting impression, empowering your networking - Whether you prefer a sleek modern or a classic style."
              title="Business Card designing"
              isPlaceOrder={true}
              classes={["mb-5"]}
              key={1}
              perPhoto={false}
              pageUrl="/services/business-card-form?key=GD_Business_Card_designing"
              price={<ConvertedPrice price={28} />}
              listItems={[
                <span>
                  <b>Quick turnaround time</b> in <b>24-48 hours</b>
                </span>,
                <span>
                  <b>Rapid Delivery</b> in <b>just 24 hours</b>
                </span>,
                <b>Free Unlimited Revisions</b>,
                <b>Access 24/7 customer support</b>,
              ]}
              cardID="business-card-design"
            />

            <ServiceCard
              singleImage={true}
              imageFront={`${process.env.REACT_APP_ADMIN_STORAGE_URL}/Logo_and_Branding_Web_1749844783.webp`}
              imageBack={`${process.env.REACT_APP_ADMIN_STORAGE_URL}/Logo_and_Branding_Web_1749844783.webp`}
              description="Want to make your real estate brand unforgettable? Our Logo and Branding service creates stunning, professional logos that grab attention and build trust. Boost your credibility, attract more clients, and close deals faster with a powerful, cohesive brand identity!"
              title="Logo and Branding"
              classes={["mb-5"]}
              isPlaceOrder={true}
              key={1}
              perPhoto={false}
              pageUrl="/services/object-removal-form?key=GD_Poster_Designing"
              price={<ConvertedPrice price={32} />}
              listItems={[
                <span>
                  <b>Quick turnaround time</b> in <b>24-48 hours</b>
                </span>,
                // <span>
                //   <b>Lightning Fast Turnaround</b> in <b>24-48 hours</b>
                // </span>,
                <span>
                  <b>Rapid Delivery</b> in <b>just 24 hours</b>
                </span>,
                <b>Free Unlimited Revisions</b>,
                <b>Risk-Free Guarantee**: 100% money-back</b>,
              ]}
              cardID="logo-and-branding"
            />

            <div id="vector-design-gd">
              <ServiceCard
                singleImage={true}
                imageFront={`${process.env.REACT_APP_ADMIN_STORAGE_URL}/Vector_Design_Web_1749844783.webp`}
                imageBack={`${process.env.REACT_APP_ADMIN_STORAGE_URL}/Vector_Design_Web_1749844783.webp`}
                description="Imagine jazzing up your property listings with eye-popping vector designs that make your homes pop off the screen. Our vector design service turns bland images into vibrant, high-resolution masterpieces that grab attention and boost your online visibility. Get ready to wow potential buyers and close deals faster with graphics that speak volumes! "
                title="Vector Design"
                isPlaceOrder={true}
                key={1}
                perPhoto={false}
                pageUrl="/services/vector-design-form?key=GD_Vector_Design"
                price={<ConvertedPrice price={38} />}
                classes={["mb-5"]}
                listItems={[
                  <span>
                    <b>Quick turnaround time</b> in <b>24-48 hours</b>
                  </span>,
                  // <span>
                  //   <b>Lightning Fast Turnaround</b> in <b>24-48 hours</b>
                  // </span>,
                  <span>
                    <b>Rapid Delivery</b> in <b>just 24 hours</b>
                  </span>,
                  <b>Free Unlimited Revisions</b>,
                  <b>Risk-Free Guarantee**: 100% money-back</b>,
                ]}
                cardID="vector-design"
              />
            </div>

            <ServiceCard
              singleImage={true}
              imageFront={`${process.env.REACT_APP_ADMIN_STORAGE_URL}/Digital_Display_Design_Web_1749844783.webp`}
              imageBack={`${process.env.REACT_APP_ADMIN_STORAGE_URL}/Digital_Display_Design_Web_1749844783.webp`}
              description="Empowers realtors with interactive digital displays that enhance property presentations. By integrating high-quality visuals, virtual tours, and detailed property information, this service helps listings stand out in a competitive market. Perfect for open houses, office lobbies, and window displays, digital displays boost engagement and attract tech-savvy buyers."
              title="Digital Display Design"
              isPlaceOrder={true}
              key={1}
              pageUrl="/services/digital-display-form?key=GD_Digital_Display_Design"
              price={<ConvertedPrice price={8} />}
              perPhoto={false}
              classes={["mb-4"]}
              listItems={[
                <span>
                  <b>Quick turnaround time</b> in <b>24-48 hours</b>
                </span>,

                <span>
                  <b>Rapid Delivery</b> in <b>just 24 hours</b>
                </span>,
                <b>Free Unlimited Revisions</b>,
                <b>Risk-Free Guarantee**: 100% money-back</b>,
              ]}
              cardID="digital-display-design"
            />
          </section>
        </div>

        {/* ========== How it works ========== */}
        <HowItWorks redirectionLink="/services/business-card-form?key=GD_Business_Card_designing" />

        <div className="hp-container">
          {/* First time */}
          <div data-aos="fade-up">
            <FirstTime />
          </div>

          {/* Industry we are catering */}
          <div data-aos="fade-up">
            <CaterIndustry />
          </div>
        </div>
      </div>
    </>
  );
};

export default GraphicDesignPage;
